import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WebbtreeVerifiedService } from '../_services/webbtree-verified.service';
import { CandidateService } from '../_services/candidate.service';
import { SearchtoolboxService } from '../_services/searchtoolbox.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../_services/local-storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TransactionService } from '../_services/transaction.service';
import { PersonSearchService } from '../_services/person-search.service';
import { GlobalService } from '../_services/global.service';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
declare const clevertap;
@Component({
  selector: 'app-education-modal',
  templateUrl: './education-modal.component.html',
  styleUrls: ['./education-modal.component.scss']
})
export class EducationModalComponent implements OnInit {
    education_form: FormGroup;
    moment = moment;
    year_list = GlobalService.yearList()
    iscurrent: any = 0;
  
    @Input() educationdetails:any
    basicdetails: any;
    successMessage: string;
    errorMessage: string;
    showEducationDetails: boolean;
    joblist: any;
    autocomplete_company: boolean = true
    companylist: any;
    locationlist: any;
    @Input() candidateid:any
    @Input() educationid:any
    @Output() passEntry : EventEmitter<any> = new EventEmitter();
    @Output() refreshCandidateListEvent: EventEmitter<any> = new EventEmitter();

    Degreesarraylist: any;
  schoolnamearraylist: any;
  educationOldOBj: any;
  degreelist: string[];
  schoollist: string[];
    constructor(public requestContract: WebbtreeVerifiedService, public modalService: NgbModal, private fb: FormBuilder, public candidateservice: CandidateService, private searchtoolbox: SearchtoolboxService,
      public router: Router, private _localstorageservice: LocalStorageService, private transactionservice: TransactionService, private sanitization: DomSanitizer, private personSearchService: PersonSearchService) {}
   


  ngOnInit(): void {
    this.education_form = this.fb.group({
      degree: [this.educationdetails ? this.educationdetails.degree : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      schoolname: [this.educationdetails ? this.educationdetails.institutename : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      fieldstudyname: [this.educationdetails ? this.educationdetails.fieldofstudy : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      startyear: [this.educationdetails ? moment(this.educationdetails.startdate).format('YYYY') : null, Validators.required],
      endyear: [this.educationdetails ? moment(this.educationdetails.enddate).format('YYYY') : null, Validators.required],
    })

    this.iscurrent = this.educationdetails ? this.educationdetails.iscurrent:0
    
    this.educationOldOBj = this.educationdetails

    //Set Error for (if end year > start year)
    this.education_form.controls["endyear"].valueChanges.subscribe(changes => {
      if ((this.education_form.get('startyear').value > this.education_form.get('endyear').value) && this.education_form.get('endyear').value != null) {
        return this.education_form['controls'].endyear.setErrors({ 'incorretEducationYear': true })
      } else {
        return this.education_form['controls'].endyear.setErrors(null)
      }
    });

    this.education_form.controls["startyear"].valueChanges.subscribe(changes => {
      if ((this.education_form.get('startyear').value > this.education_form.get('endyear').value) && this.education_form.get('startyear').value != null && this.education_form.get('endyear').value != null ) {
        return this.education_form['controls'].endyear.setErrors({ 'incorretEducationYear': true })
      } else {
        return this.education_form['controls'].endyear.setErrors(null)
      }
    });
  }

  
  getautocompleteData(type, input): Observable<any> {
    let data = {
      "dropdowntype": type,
      "searchedstring": input
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (res.status == 'success') {
        subject.next(res.data);
      } else {
        subject.next([])
      }
    })
    return subject.asObservable();
  }

  //Typeahead for Degree
  searchDegree(e) {
    if (e.target.value != '' && e.target.value.length > 2) {
      this.getautocompleteData('educational degrees', e.target.value).subscribe((res) => {
        this.degreelist = res
      })
    } else {
      this.degreelist = []
    }
  }

  //Typeahead for SchoolName
  searchSchool(e) {
    if (e.target.value != '' && e.target.value.length > 2) {
      this.getautocompleteData('institutes', e.target.value).subscribe((res) => {
        this.schoollist = res
      })
    } else {
      this.schoollist = []
    }
  }

  //Edit Education Div
  EditEducationDetails(education:any) {
    this.educationOldOBj = education
    this.educationid = education ? education.candidateeducationid : null

    this.education_form = this.fb.group({
      degree: [education ? education.degree : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      schoolname: [education ? education.institutename : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      fieldstudyname: [education ? education.fieldofstudy : '', [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      startyear: [education ? moment(education.startdate).format('YYYY') : null, Validators.required],
      endyear: [education ? moment(education.enddate).format('YYYY') : null, Validators.required],
    })
    // this.showAllDetails = false;
    // this.showExperienceDetails = false
    // this.showAdditionalDetails = false
    // this.showEducationDetails = true
    // this.showEditContacts = false;
    // this.showBasicDetails = false;    

  }

  //Add Education Details
  addeducation() {
    let data = {}
    if (this.education_form.valid) {
      data = {
        candidateeducationid: this.educationid ? this.educationid : null,
        candidatenumber: this.candidateid,
        degree: this.education_form.value.degree,
        institutename: this.education_form.value.schoolname,
        fieldofstudy: this.education_form.value.fieldstudyname,
        startdate: moment(this.education_form.value.startyear).format('YYYY'),
        enddate: moment(this.education_form.value.endyear).format('YYYY'),
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      if (!this.educationid) {
        data['activitylog'] = [{
          "action": "'create'",
          "tablename": "'candidateeducation'",
          "type": "'education'",
          "updatedfieldname": "'null'",
          "oldvalue": "'null'",
          "newvalue": "'null'"
        }]
      } else if (this.educationid) {
        if ('startdate' in this.educationOldOBj) {
          this.educationOldOBj['startdate'] = moment(this.educationOldOBj.startdate).format('YYYY')
        } if ('enddate' in this.educationOldOBj) {
          this.educationOldOBj['enddate'] = moment(this.educationOldOBj.enddate).format('YYYY')
        }
        let activity = [];
        let educationOldObj = {
          degree: this.educationOldOBj.degree,
          institutename: this.educationOldOBj.institutename,
          fieldofstudy: this.educationOldOBj.fieldofstudy,
          startdate: this.educationOldOBj.startdate,
          enddate: this.educationOldOBj.enddate,
        }
        let result = Object.keys(educationOldObj).filter(k => educationOldObj[k] !== data[k]);
        result.map((elem, index) => {
          activity.push({
            action: "'update'",
            tablename: "'candidateeducation'",
            type: "'education'",
            updatedfieldname: "'" + elem + "'",
            oldvalue: educationOldObj[elem] ? "'" + educationOldObj[elem].replace(/'/g, '') + "'" : "'null'",
            newvalue: data[elem] ? "'" + data[elem].replace(/'/g, '') + "'" : "'null'",
          })
        })
        if (activity.length > 0) {
          data['activitylog'] = activity
        }
      }

      this.candidateservice.updateCandidateEducation(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Education Added Successfully', 'success')
          this.candidateservice.createCandidateData();
          // this.showAllDetail('details')
          this.passEntry.emit('success')
          //- Clevertap Edit Profile event
          let ctObj = {
            "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
            "Job title": this.basicdetails.jobtitle,
            "Company Name": this.basicdetails.companyname,
            "Source": this.basicdetails.source,
            "Location": this.basicdetails.locationname,
            "Origin": "Web app"
          }
          this.cleverTapEvent("Edit Profile", ctObj);
        } else {
          this.toastmessage('Something Went Wrong', 'success')
          this.passEntry.emit('error')

        }
      })
    } else {
      this.validateAllFormFields(this.education_form);
    }

  }
  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
